import { Table, NavLink, Nav, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown, Input, Button, Modal, ModalBody, ModalFooter, ModalHeader, Form, FormGroup, Label, ButtonDropdown, Dropdown, DropdownItem, Spinner } from "reactstrap";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { BsCheckCircle } from "react-icons/bs";
import { BsQuestionCircle } from "react-icons/bs";
import { ReactComponent as CrossIcon } from "../../../../../assets/utils/images/svgs/Cross.svg";
import { ReactComponent as BlueClock } from "../../../../../assets/utils/images/svgs/BlueClock.svg";
import Tippy from "@tippyjs/react";
import { ReactComponent as Memo } from "../../../../../assets/utils/images/svgs/Memo.svg";
import { ReactComponent as Football } from "../../../../../assets/utils/images/svgs/Coorfootball.svg";
import { ReactComponent as Thumbsup } from "../../../../../assets/utils/images/svgs/ThumbsUp-Gray.svg";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import TextLimit from "Api/TextLimit";
import { ReactComponent as Small_Arrow } from "../../../../../assets/utils/images/svgs/Small_Arrow.svg"
import { ReactComponent as Save } from "../../../../../assets/utils/images/svgs/save_two.svg";
import { ReactComponent as Menu } from "../../../../../assets/utils/images/svgs/Menu-dots.svg";
import { ReactComponent as DeleteIcon } from "../../../../../assets/utils/images/svgs/Delete.svg";
import { ReactComponent as FootballIcon } from "../../../../../assets/utils/images/svgs/Coorfootball.svg";
import { ReactComponent as PlanningIcon } from "../../../../../assets/utils/images/svgs/PlanningIcon.svg";
import { ReactComponent as CopyIcon } from "../../../../../assets/utils/images/svgs/Copy.svg";
import { ReactComponent as DomunentSearch } from "../../../../../assets/utils/images/svgs/DocumentSearch.svg";
import { ReactComponent as VervangerIcon } from "../../../../../assets/utils/images/svgs/vervangerr.svg";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import EvalulerenModal from "./TableModals/EvalulerenModal";
import DagdeelMemo from "./TableModals/DagdeelMemo";
import dayjs from 'dayjs';
import TitleModal from "Components/Modal/InfoModal/TitleModal";
import { useNavigate } from 'react-router-dom';
import { useRemoveGym, useSaveEvaluation, useUpdateMemo, useUpdateShiftType, useUpdateUserEgymStatus, useUpdateWtfValue } from "Api/Coordinator/Verzoeken";
dayjs.extend(customParseFormat);


const RequestList = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [opmerkingId, setOpmerkingId] = useState(0);
    const [opmerkingValue, setOpmerkingValue] = useState('');
    const [showMemoModal, setShowMemoModal] = useState(false);
    const [memoPayloadData, setMemoPayloadData] = useState({});
    const [showEvalulerenModal, setShowEvalulerenModal] = useState(false);
    const [evalulerenModalData, setEvalulerenModalData] = useState('');
    const navigate = useNavigate();
    const params = useParams();
    const substitutionId = params.id || '';
    const tableData = props.list || [];
    const { trigger: updateShiftTypeMutation } = useUpdateShiftType();
    const { trigger: updateWtfValueMutation } = useUpdateWtfValue();
    const { trigger: updateMemoMutation } = useUpdateMemo();
    const { trigger: updateGymMutation } = useUpdateUserEgymStatus();
    const { trigger: removeGymMutation } = useRemoveGym();
    const { trigger: saveEvaluationMutation } = useSaveEvaluation();
    const [openDropdown, setOpenDropdown] = useState(null);
    const [openMenu, setOpenMenu] = useState(null);
    const [planningLoadingId, setPlanningLoadingId] = useState(null);
    const [overrides, setOverrides] = useState({});

    const setOverride = (field, id, value) =>
        setOverrides((p) => ({ ...p, [`${field}-${id}`]: value }));

    const getValue = (field, id, original) =>
        overrides[`${field}-${id}`] ?? original;

    const toggleMenu = (id) => {
        if (!id) return;
        setOpenMenu((prev) => (prev === id ? null : id));
    };

    const handlePlannen = (data) => {
        if (planningLoadingId) return;
        setPlanningLoadingId(data.iSubsDateId);        // show spinner
        navigate(`/verzoeken/planscreen/${data.iSubstitutionId}/${data.iSubsDateId}`);
    };


    const toggleDropdown = (id) => {
        setOpenDropdown((prev) => (prev === id ? null : id));
    };

    useEffect(() => {
        moment.locale('fr');
    }, [props.statusCount]);

    const iconSwitch = (param) => {
        switch (param) {
            case 'Ingepland':
                return <Tippy content={param} placement="bottom"><span><BsCheckCircle color='#39A825' fontSize={"18px"} /></span></Tippy>;
            case 'Aangevraagd':
                return <Tippy content={param} placement="bottom"><span><BsQuestionCircle color='#F2983E' fontSize={"18px"} /></span></Tippy>;
            case 'Geannuleerd':
                return <Tippy content={param} placement="bottom"><span><CrossIcon color='#FB2E5F' fontSize={"24px"} /></span></Tippy>;
            case 'Voorlopig':
                return <Tippy content={param} placement="bottom"><span><BlueClock color='#FB2E5F' fontSize={"20px"} /></span></Tippy>;
            default:
                return <Tippy content={'Openstaand'} placement="bottom"><span>-</span></Tippy>;
        }
    }

    const updateShiftdayType = (iSubsDateId, iDayTypeId) => {
        setOverride('dt', iSubsDateId, iDayTypeId);
        let formData = new FormData();
        formData.append('iSubstitutionId', substitutionId);
        formData.append('iSubsDateId', iSubsDateId);
        formData.append('iDayTypeId', iDayTypeId);

        updateShiftTypeMutation({
            data: formData
        }).then((response) => {
            if (response?.status === true || response?.data?.status === true) {
                props.mutate?.();
            }
        })
            .catch((error) => console.log("catch error:", error));
    }
    const updateWtfValue = (iSubsDateId, value) => {
        let formData = new FormData();
        formData.append('iSubstitutionId', substitutionId);
        formData.append('iSubsDateId', iSubsDateId);
        formData.append('value', value);

        updateWtfValueMutation({
            data: formData
        }).catch((error) => console.log("catch error:", error));
    }
    const updateWtfWithCheck = (iSubsDateId, wtf, wtfValue, vHour, vHourLang, vHourParttimers) => {

        let formData = new FormData();
        formData.append('iSubstitutionId', substitutionId);
        formData.append('iSubsDateId', iSubsDateId);

        if (wtf == 'K') {
            formData.append('value', vHour);
        } else if (wtf == 'L') {
            formData.append('value', vHourLang);
        } else if (wtf == 'P') {
            formData.append('value', vHourParttimers);
        } else if (wtf == 'H') {
            formData.append('value', wtfValue);
        } else if (wtf == '?') {
            formData.append('value', '-');
        }
        updateWtfValueMutation({
            data: formData
        }).then((response) => {
            if (response?.status === true || response?.data?.status === true) {
                toast["success"]("wtf-waarde is succesvol bijgewerkt");
            }
        }).catch((error) => console.log("catch error:", error));

    }
    const updateMemo = () => {
        let formData = new FormData();
        formData.append('id', substitutionId);
        formData.append('iSubsDateId', opmerkingId);
        formData.append('type', 5);
        formData.append('memo', opmerkingValue);

        updateMemoMutation({
            data: formData
        }).then((response) => {

            if (response?.status === 200 || response?.success === true) {
                toast["success"]("Memo succesvol opgeslagen");
                setShowMemoModal(false);
                props.mutate?.();
            } else {
                toast["error"]("Er is een fout opgetreden bij het opslaan van de memo.");
            }
        }).catch((error) => {
            console.log("catch error:", error);
            toast["error"]("Er is een fout opgetreden bij het opslaan van de memo.");
        })
    }
    const handleChangedStatus = (substitutionId) => {
        const emailSmsRecipient = {
            id: substitutionId
        };

        props.setEmailAndSmsRecipients((prev) => {
            const exists = prev.some((item) => item.id === emailSmsRecipient.id);
            if (!exists) {
                return [...prev, emailSmsRecipient];
            }
            return [...prev];
        });
    }

    if (!props.list) return null;

    const renderMenuDropdown = ({ data, day, dayPart, menuId }) => {
        const isUnplanned = data && data?.iSubstitutorAdminId === 0 && data?.Name === "";
        const isPlanned = data && data?.iSubstitutorAdminId !== 0 && data?.Name !== "";
        const isPlanningLoading = planningLoadingId === data?.iSubsDateId;

        return (
            <Dropdown isOpen={openMenu === menuId} toggle={() => toggleMenu(menuId)}>
                <DropdownToggle color="link" className="p-0">
                    <Menu />
                </DropdownToggle>
                <DropdownMenu
                    end
                    strategy="fixed"
                    className="rm-pointers dropdown-menu-lg verzoeken-menu-dropdown"
                >
                    {isUnplanned && (
                        <NavLink
                            className="link-gap navlink-border"
                            toggle={false}
                            disabled={!!planningLoadingId}
                            onClick={() => handlePlannen(data)}
                        >
                            <span>
                                {isPlanningLoading
                                    ? <Spinner size="sm" color="primary" />
                                    : <PlanningIcon />}
                            </span>
                            <span>Plannen</span>
                        </NavLink>
                    )}

                    {isUnplanned && (
                        <NavLink
                            className="link-gap navlink-border"
                            onClick={() =>
                                navigate(`/verzoeken/vervanger-zoeken/${data.iSubstitutionId}/${data.iSubsDateId}/${data.iCommunityId}`)
                            }
                        >
                            <span><VervangerIcon /></span>
                            <span>Vervanger zoeken</span>
                        </NavLink>
                    )}

                    {isUnplanned ? (
                        <NavLink
                            className="link-gap navlink-border"
                            onClick={() => props.confirmDelete({ iSubsDateId: data?.iSubsDateId }, 'dagdeel')}
                        >
                            <span><DeleteIcon /></span>
                            <span>Dagdeel verwijderen</span>
                        </NavLink>
                    ) : (
                        <NavLink
                            className="link-gap navlink-border"
                            onClick={() =>
                                props.confirmDelete({
                                    iSubstitutionId: data?.iSubstitutionId,
                                    iSubsDateId: data?.iSubsDateId,
                                    iSubstitutorAdminId: data?.iSubstitutorAdminId
                                }, 'vervanger')
                            }
                        >
                            <span><DeleteIcon /></span>
                            <span>Vervanger verwijderen</span>
                        </NavLink>
                    )}

                    <NavLink
                        className="link-gap navlink-border"
                        onClick={() => {
                            data?.eGym == '+' ? handleDeleteGym(data) : handleGymClick(data, day, dayPart);
                        }}
                    >
                        <span><FootballIcon /></span>
                        <span>Gym wijzigen</span>
                    </NavLink>

                    <NavLink
                        className="link-gap navlink-border"
                        onClick={() => {
                            setShowMemoModal(true);
                            setMemoPayloadData((prev) => ({
                                ...prev,
                                id: data?.iSubstitutionId,
                                iSubsDateId: data?.iSubsDateId
                            }));
                            setOpmerkingValue(data?.vMemo);
                        }}
                    >
                        <span><Memo /></span>
                        <span>Memo wijzigen</span>
                    </NavLink>

                    {isPlanned && (
                        <NavLink
                            className="link-gap navlink-border"
                            onClick={() => {
                                setShowEvalulerenModal(true);
                                setEvalulerenModalData(data);
                            }}
                        >
                            <span><DomunentSearch /></span>
                            <span>Evalueren</span>
                        </NavLink>
                    )}
                </DropdownMenu>
            </Dropdown>
        );
    };

    const handleMemoSubmit = (values, setSubmitting) => {
        let formData = new FormData();
        formData.append('id', memoPayloadData.id);
        formData.append('iSubsDateId', memoPayloadData.iSubsDateId);
        formData.append('type', 5);
        formData.append('memo', opmerkingValue ? opmerkingValue : '');
        updateMemoMutation({
            data: formData
        }
        ).then((response) => {

            if (response.status === true) {
                toast["success"]("Memo succesvol opgeslagen")
                setShowMemoModal(false);
                props.getRequests();
            } else {
                toast["error"]("Er is een fout opgetreden bij het opslaan van de memo.");

            }
        })
            .catch((error) => {
                console.log("catch error:", error);
                toast["error"]("Er is een fout opgetreden bij het opslaan van de memo.");
            }
            ).finally(() => {
                setSubmitting(false);
            });
    }

    const handleGymClick = (data, day, dayPart) => {
        let dayId = [];

        const formattedDate = dayjs(day, 'DD-MM-YYYY').format('YYYY/MM/DD');

        let weekDayNum = dayjs(formattedDate).day();

        if (dayPart === "ochtend") {
            dayId = [weekDayNum * 2 - 1]
        } else if (dayPart === "middag") {
            dayId = [weekDayNum * 2]
        } else {
            dayId = [weekDayNum * 2 - 1, weekDayNum * 2]
        }

        const payloadData = {
            subDateId: data?.iSubsDateId,
            gym: dayId
        }

        updateGymMutation({
            data: payloadData
        }).then((response) => {

            if (response?.status === "success") {
                toast["success"]("Gym succesvol gewijzigd")

                props.getRequests();

            } else {
                toast.error("Gym wijzigen is mislukt. Probeer het opnieuw.");
            }
        }
        ).catch(() => {
            toast.error("Gym wijzigen is mislukt. Probeer het opnieuw.");
        })
    }

    const handleDeleteGym = (data) => {
        const payloadData = {
            iSubDateId: data?.iSubsDateId
        }
        removeGymMutation({
            data: payloadData
        }).then((response) => {
            if (response?.status === "success") {
                toast["success"]("Sportschool succesvol verwijderd")
                props.getRequests();
            } else {
                toast.error("Gym wijzigen is mislukt. Probeer het opnieuw.");
            }
        }
        ).catch(() => {
            toast.error("Gym wijzigen is mislukt. Probeer het opnieuw.");
        })
    }


    const handleEvalulerenSubmit = (values, setSubmitting, setFieldError) => {
        const payloadData = {
            iSubsDateId: evalulerenModalData?.iSubsDateId,
            iSchoolId: evalulerenModalData?.iSchoolId,
            vSubsDate: evalulerenModalData?.vSubsDate,
            eUser: [],
            deleteEUser: [],
        };

        const emailFlags = [
            { value: values?.emailToSchool, id: 1 },
            { value: values?.emailToVervanger, id: 2 },
        ];

        emailFlags.forEach(({ value, id }) => {
            if (value !== 0) {
                payloadData.eUser.push(id);
            } else {
                payloadData.deleteEUser.push(id);
            }
        });

        const isCancelling = values?.emailToSchool === 0 && values?.emailToVervanger === 0;

        if (!isCancelling && values?.emailToSchool === 0 && values?.emailToVervanger === 0) {
            setFieldError("selection", "U moet tenminste één van de twee opties selecteren.");
            return;
        }

        saveEvaluationMutation({
            data: payloadData
        }).then((response) => {
            const targetSubsDateId = evalulerenModalData?.iSubsDateId;
            const backendMessage = response?.data || '';
            const isAlreadyExistsError = backendMessage.includes('al evaluaties') || backendMessage.includes('already');

            if (response?.status || isCancelling || isAlreadyExistsError) {
                let successMessage;
                if (isCancelling) {
                    successMessage = 'Evaluatie geannuleerd';
                } else if (isAlreadyExistsError) {
                    successMessage = 'Evaluatie bijgewerkt';
                } else {
                    successMessage = backendMessage || 'Evaluatie opgeslagen';
                }

                setShowEvalulerenModal(false);
                props.getRequests();
            } else {
                toast["error"](backendMessage || 'Er is een fout opgetreden bij het opslaan van de evaluatie.');
            }
        }).catch(() => {
            toast["error"]("Er is een fout opgetreden bij het opslaan van de evaluatie.");
        }).finally(() => {
            setSubmitting(false);
        });
    }

    const toggleEvalulerenModal = () => {
        setShowEvalulerenModal(!showEvalulerenModal);
        setEvalulerenModalData('');
    }

    return (
        <>
            <Table hover size="sm" className="mb-0 coor-verzoeken-table">
                <thead>
                    <tr>
                        <th className="text-lef w-32 table-right-border" colSpan="2">&nbsp;</th>
                        <th colSpan="6" className="table-right-border text-center">Ochtend</th>
                        <th colSpan="6" className="text-center">Middag</th>
                    </tr>
                    <tr>
                        <th></th>
                        <th className="text-left table-right-border" style={{ width: '80px' }}>Datum</th>
                        <th>Vervanger</th>
                        <th>Status</th>
                        <th>DT</th>
                        <th>WTF</th>
                        <th></th>
                        <th className="table-right-border">Actie</th>


                        <th>Vervanger</th>
                        <th>Status</th>
                        <th>DT</th>
                        <th>WTF</th>
                        <th></th>
                        <th>Actie</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData && tableData.length > 0 ? (
                        tableData.map((block, i) => {
                            const isLastItem = i === tableData.length - 1;
                            return (
                                <tr key={`${block.day}-${i}`} ref={isLastItem ? props.lastItemRef : null}>
                                    <td className="text-capitalize">
                                        {new Date(moment(block.day, 'DD-MM-YYYY')).toLocaleDateString("nl-NL", { weekday: 'short' })}
                                    </td>
                                    <td className="cursor-pointer table-right-border ml-0" style={{ width: '80px' }}>
                                        {new Date(moment(block.day, 'DD-MM-YYYY')).toLocaleDateString("nl-NL", {
                                            year: '2-digit',
                                            month: '2-digit',
                                            day: '2-digit'
                                        })}
                                    </td>
                                    {
                                        block.data.Ochtend ?
                                            <>
                                                <td>
                                                    {
                                                        block.data.Ochtend.Name !== '' && block.data.Ochtend.Name !== null ?
                                                            window.innerWidth > 1250 ? TextLimit.AfwezigeLimitOptionOne(block.data.Ochtend.vFirstName, block.data.Ochtend.vMiddleName, block.data.Ochtend.vLastName)
                                                                : TextLimit.AfwezigeLimitOptionTwo(block.data.Ochtend.vFirstName, block.data.Ochtend.vMiddleName, block.data.Ochtend.vLastName) : '-'
                                                    }
                                                </td>
                                                <td className="direction-row">
                                                    <div className="d-flex">
                                                        {
                                                            block.data.Ochtend.iSubstitutorAdminId !== 0 ?
                                                                <ButtonDropdown
                                                                    isOpen={openDropdown === `ochtend-${i}`}
                                                                    toggle={() => toggleDropdown(`ochtend-${i}`)}
                                                                >
                                                                    <DropdownToggle color="link" className="p-0 me-1">
                                                                        {iconSwitch(block.data.Ochtend.eSubStatus)}
                                                                    </DropdownToggle>
                                                                    <DropdownMenu end strategy="fixed" className="rm-pointers dropdown-menu-lg functies-dropdown-width">

                                                                        <Nav vertical className="dropdown-custom-link">
                                                                            <NavLink
                                                                                className="link-gap"
                                                                                onClick={() => {
                                                                                    handleChangedStatus(block.data.Ochtend.iSubstitutorAdminId);
                                                                                    props.changeStatus(
                                                                                        block.data.Ochtend.iSubsDateId,
                                                                                        "Ingepland",
                                                                                        block.data.Ochtend
                                                                                    );
                                                                                    setOpenDropdown(null);   // Close dropdown
                                                                                }}
                                                                            >
                                                                                <span><BsCheckCircle color="#39A825" fontSize="18px" /></span>
                                                                            </NavLink>

                                                                            <NavLink
                                                                                className="link-gap"
                                                                                onClick={() => {
                                                                                    handleChangedStatus(block.data.Ochtend.iSubstitutorAdminId);
                                                                                    props.changeStatus(
                                                                                        block.data.Ochtend.iSubsDateId,
                                                                                        "Aangevraagd",
                                                                                        block.data.Ochtend
                                                                                    );
                                                                                    setOpenDropdown(null);   // Close dropdown
                                                                                }}
                                                                            >
                                                                                <span><BsQuestionCircle color='#F2983E' fontSize={"18px"} /> </span>
                                                                            </NavLink>

                                                                            <NavLink
                                                                                className="link-gap"
                                                                                onClick={() => {
                                                                                    handleChangedStatus(block.data.Ochtend.iSubstitutorAdminId);
                                                                                    props.changeStatus(
                                                                                        block.data.Ochtend.iSubsDateId,
                                                                                        "Geannuleerd",
                                                                                        block.data.Ochtend
                                                                                    );
                                                                                    setOpenDropdown(null);   // Close dropdown
                                                                                }}
                                                                            >
                                                                                <span><CrossIcon color='#FB2E5F' fontSize={"24px"} /> </span>
                                                                            </NavLink>

                                                                            <NavLink
                                                                                className="link-gap"
                                                                                onClick={() => {
                                                                                    handleChangedStatus(block.data.Ochtend.iSubstitutorAdminId);
                                                                                    props.changeStatus(
                                                                                        block.data.Ochtend.iSubsDateId,
                                                                                        "Voorlopig",
                                                                                        block.data.Ochtend
                                                                                    );
                                                                                    setOpenDropdown(null);   // Close dropdown
                                                                                }}
                                                                            >
                                                                                <span><BlueClock color='#FB2E5F' fontSize={"24px"} /> </span>
                                                                            </NavLink>

                                                                        </Nav>
                                                                    </DropdownMenu>
                                                                </ButtonDropdown>
                                                                : <span className="me-1" >-</span>
                                                        }
                                                        {
                                                            block.data.Ochtend.Name === '' && block.data.Ochtend.eGym !== '+' && block.data.Ochtend.iSubstitutorAdminId !== 0 && <span className="me-1" >-</span>
                                                        }
                                                        {
                                                            block.data.Ochtend.vMemo ?
                                                                <>
                                                                    <span className="me-1"><TitleModal data={block.data.Ochtend.vMemo || ''} title="Memo" Icon={Memo} /></span>
                                                                </> : ''
                                                        }
                                                        {
                                                            block.data.Ochtend.eGym == '+' &&
                                                            <span className="me-1 d-flex align-items-center"><Football /></span>
                                                        }
                                                        {
                                                            block.data.Ochtend.evalImage !== '' &&
                                                            <span><Thumbsup /></span>
                                                        }
                                                    </div>
                                                </td>
                                                <td>
                                                    {block.data.Ochtend.iSubstitutorAdminId != 0 ?
                                                        <select
                                                            value={getValue('dt', block.data.Ochtend.iSubsDateId, block.data.Ochtend.iDayTypeId || "0")}
                                                            onChange={(e) => updateShiftdayType(block.data.Ochtend.iSubsDateId, e.target.value)}
                                                        >
                                                            <option value="0">?</option>
                                                            {props.dayTypeList.map((key) => {
                                                                return (
                                                                    <option key={key.id} value={key.id}>{key.abbr}</option>
                                                                )
                                                            })
                                                            }
                                                        </select> : block.data.Ochtend.Name != '' ? block.data.Ochtend.ctDefaultValue : '-'
                                                    }

                                                </td>
                                                <td className="coord-request-table-td">
                                                    <div className="wtf">
                                                        {
                                                            block.data.Ochtend.Name !== '' ?
                                                                (
                                                                    <>
                                                                        <span>
                                                                            <select
                                                                                value={getValue('wtf', block.data.Ochtend.iSubsDateId, block.data.Ochtend.wtf || "?")}
                                                                                onChange={(e) => {
                                                                                    setOverride('wtf', block.data.Ochtend.iSubsDateId, e.target.value);
                                                                                    props.updateWtf(block.data.Ochtend.iSubsDateId, e.target.value);
                                                                                }}
                                                                            >
                                                                                <option value="?">?</option>
                                                                                <option value="K">K</option>
                                                                                <option value="L">L</option>
                                                                                <option value="P">P</option>
                                                                                <option value="H">H</option>
                                                                            </select>
                                                                        </span>

                                                                    </>
                                                                ) : '-'
                                                        }
                                                    </div>
                                                </td>
                                                <td className="coord-request-table-td">
                                                    {props?.showWTFValue && <span>
                                                        <Input
                                                            style={{ width: '60px', border: 'none' }}
                                                            value={block.data.Ochtend.wtfValue !== null ? block.data.Ochtend.wtfValue : '-'}
                                                            onChange={(e) => {
                                                                updateWtfValue(block.data.Ochtend.iSubsDateId, e.target.value)
                                                            }}
                                                            min="0"
                                                            max="1"
                                                            size="5"
                                                            maxlength="7"
                                                            readOnly={block.data.Ochtend.wtf != 'H' ? true : false}
                                                        />
                                                    </span>}
                                                </td>

                                                <td className="icon-styling table-right-border">
                                                    {renderMenuDropdown({ data: block?.data?.Ochtend, day: block?.day, dayPart: "ochtend", menuId: `menu-ochtend-${i}` })}
                                                </td>
                                            </>
                                            : <td colSpan="6" className="text-center table-right-border empty-table-row"></td>
                                    }

                                    {
                                        block.data.Middag ?
                                            <>
                                                <td>
                                                    {
                                                        block.data.Middag.Name !== '' && block.data.Middag.Name !== null ?
                                                            (window.innerWidth > 1250 ? TextLimit.AfwezigeLimitOptionOne(block.data.Middag.vFirstName, block.data.Middag.vMiddleName, block.data.Middag.vLastName)
                                                                : TextLimit.AfwezigeLimitOptionTwo(block.data.Middag.vFirstName, block.data.Middag.vMiddleName, block.data.Middag.vLastName)) : '-'
                                                    }
                                                </td>
                                                <td>
                                                    {
                                                        block.data.Middag.iSubstitutorAdminId !== 0 ?
                                                            <ButtonDropdown
                                                                isOpen={openDropdown === `middag-${i}`}
                                                                toggle={() => toggleDropdown(`middag-${i}`)}
                                                            >
                                                                <DropdownToggle color="link" className="p-0 me-1">

                                                                    {iconSwitch(block.data.Middag.eSubStatus)}

                                                                </DropdownToggle>
                                                                <DropdownMenu end className="rm-pointers dropdown-menu-lg functies-dropdown-width">

                                                                    <Nav vertical className="dropdown-custom-link">

                                                                        <NavLink
                                                                            className="link-gap"
                                                                            onClick={() => {
                                                                                handleChangedStatus(block.data.Middag.iSubstitutorAdminId);
                                                                                props.changeStatus(
                                                                                    block.data.Middag.iSubsDateId,
                                                                                    "Ingepland",
                                                                                    block.data.Middag
                                                                                );
                                                                                setOpenDropdown(null);
                                                                            }}
                                                                        >
                                                                            <span><BsCheckCircle color="#39A825" fontSize="18px" /></span>
                                                                        </NavLink>

                                                                        <NavLink
                                                                            className="link-gap"
                                                                            onClick={() => {
                                                                                handleChangedStatus(block.data.Middag.iSubstitutorAdminId);
                                                                                props.changeStatus(
                                                                                    block.data.Middag.iSubsDateId,
                                                                                    "Aangevraagd",
                                                                                    block.data.Middag
                                                                                );
                                                                                setOpenDropdown(null);
                                                                            }}
                                                                        >
                                                                            <span><BsQuestionCircle color='#F2983E' fontSize={"18px"} /> </span>
                                                                        </NavLink>
                                                                        <NavLink
                                                                            className="link-gap"
                                                                            onClick={() => {
                                                                                handleChangedStatus(block.data.Middag.iSubstitutorAdminId);
                                                                                props.changeStatus(
                                                                                    block.data.Middag.iSubsDateId,
                                                                                    "Geannuleerd",
                                                                                    block.data.Middag
                                                                                );
                                                                                setOpenDropdown(null);
                                                                            }}
                                                                        >
                                                                            <span><CrossIcon color='#FB2E5F' fontSize={"24px"} /> </span>
                                                                        </NavLink>
                                                                        <NavLink
                                                                            className="link-gap"
                                                                            onClick={() => {
                                                                                handleChangedStatus(block.data.Middag.iSubstitutorAdminId);
                                                                                props.changeStatus(
                                                                                    block.data.Middag.iSubsDateId,
                                                                                    "Voorlopig",
                                                                                    block.data.Middag
                                                                                );
                                                                                setOpenDropdown(null);
                                                                            }}
                                                                        >
                                                                            <span><BlueClock color='#FB2E5F' fontSize={"24px"} /> </span>
                                                                        </NavLink>

                                                                    </Nav>
                                                                </DropdownMenu>
                                                            </ButtonDropdown>
                                                            : <span className="me-1" >-</span>

                                                    }
                                                    {
                                                        block.data.Middag.Name === '' && block.data.Middag.eGym !== '+' && block.data.Middag.iSubstitutorAdminId !== 0 && <span className="me-1" >-</span>
                                                    }
                                                    {
                                                        block.data.Middag.vMemo ?
                                                            <>
                                                                <span className="me-1"><TitleModal data={block.data.Middag.vMemo || ''} title="Memo" Icon={Memo} /></span>
                                                            </> : ''
                                                    }
                                                    {
                                                        block.data.Middag.eGym == '+' &&
                                                        <Football className="me-1" />
                                                    }
                                                    {
                                                        block.data.Middag.evalImage !== '' &&
                                                        <span><Thumbsup /></span>
                                                    }
                                                </td>
                                                <td>
                                                    {block.data.Middag.iSubstitutorAdminId != 0 ?
                                                        <select
                                                            value={getValue('dt', block.data.Middag.iSubsDateId, block.data.Middag.iDayTypeId || "0")}
                                                            onChange={(e) => updateShiftdayType(block.data.Middag.iSubsDateId, e.target.value)}
                                                        >                                                         
                                                           <option value="0">?</option>
                                                            {props.dayTypeList.map((key) => {
                                                                return (
                                                                    <option key={key.id} value={key.id}>{key.abbr}</option>
                                                                )
                                                            })
                                                            }
                                                        </select> : block.data.Middag.Name != '' ? block.data.Middag.ctDefaultValue : '-'
                                                    }

                                                </td>
                                                <td className="coord-request-table-td">
                                                    <div style={{ display: 'flex', alignItems: 'center', borderBottom: 'none', height: '100%' }}>
                                                        {
                                                            block.data.Middag.Name !== '' ?
                                                                (
                                                                    <select
                                                                        value={getValue('wtf', block.data.Middag.iSubsDateId, block.data.Middag.wtf || "?")}
                                                                        onChange={(e) => {
                                                                            setOverride('wtf', block.data.Middag.iSubsDateId, e.target.value);
                                                                            updateWtfWithCheck(block.data.Middag.iSubsDateId, e.target.value, block.data.Middag.wtfValue, block.data.Middag.vHour, block.data.Middag.vHourLang, block.data.Middag.vHourParttimers);
                                                                            props.updateWtf(block.data.Middag.iSubsDateId, e.target.value);
                                                                        }}
                                                                    >
                                                                        <option value="?">?</option>
                                                                        <option value="K">K</option>
                                                                        <option value="L">L</option>
                                                                        <option value="P">P</option>
                                                                        <option value="H">H</option>
                                                                    </select>
                                                                ) : '-'
                                                        }
                                                    </div>
                                                </td>
                                                <td className="coord-request-table-td">
                                                    {props?.showWTFValue && <Input
                                                        style={{ width: '60px', border: 'none' }}
                                                        value={block.data.Middag.Name !== '' && block.data.Middag.wtfValue !== null ? block.data.Middag.wtfValue : '-'}
                                                        onChange={(e) => {
                                                            updateWtfValue(block.data.Middag.iSubsDateId, e.target.value)
                                                        }}
                                                        min="0"
                                                        max="1"
                                                        size="5"
                                                        maxlength="7"
                                                        readOnly={block.data.Middag.wtf != 'H' ? true : false}
                                                    />}
                                                </td>
                                                <td className="icon-styling">
                                                    {renderMenuDropdown({ data: block?.data?.Middag, day: block?.day, dayPart: "middag", menuId: `menu-middag-${i}` })}
                                                </td>
                                            </>
                                            : <td colSpan="6" className="text-center empty-table-row"></td>
                                    }
                                </tr>
                            )
                        })) : (
                        <tr>
                            <td colSpan="14" className="text-center py-4 text-muted fw-bolder">
                                Alle dagdelen uit dit verzoek zijn verwijderd
                            </td>
                        </tr>
                    )}

                </tbody>
            </Table>

            <Modal id={"tooltip"} isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} className="modal-dialog__over feedback-modal-style opmerking-modal-styling">
                <ModalHeader>
                    <div className="modal-header-styling">
                        Opmerking
                    </div>
                    <div className="cross-icon-color">
                        <i className="nav-link-icon lnr-cross m-1 cursor-pointer" onClick={() => setIsOpen(false)}> </i>
                    </div>
                </ModalHeader>

                <ModalBody className="d-flex bg-white rounded">
                    <textarea
                        value={opmerkingValue}
                        className="form-style opmerking-input-styling"
                        rows="6"
                        onChange={(e) => setOpmerkingValue(e.target.value)}
                    ></textarea>
                </ModalBody>
                <ModalFooter>
                    <Button className="d-flex align-items-center btn-color-style  opslaan-btn" size="sm" outline color="primary" onClick={() => updateMemo()}>
                        <Save />
                        Opslaan
                    </Button>
                    <Button className="d-flex align-items-center btn-color-style back-btn" size="sm" outline color="primary" onClick={() => setIsOpen(false)}>
                        <Small_Arrow />
                        Terug
                    </Button>
                </ModalFooter>
            </Modal>

            <DagdeelMemo showMemoModal={showMemoModal} setShowMemoModal={setShowMemoModal} opmerkingValue={opmerkingValue} setOpmerkingValue={setOpmerkingValue} handleMemoSubmit={handleMemoSubmit} />

            <EvalulerenModal evalulerenModalData={evalulerenModalData} showEvalulerenModal={showEvalulerenModal} toggleEvalulerenModal={toggleEvalulerenModal} handleEvalulerenSubmit={handleEvalulerenSubmit} />

        </>

    );
};

export default RequestList;